module.exports = __webpack_public_path__ + "img/_super_feature_01.d249930d.jpg";